export default "__VITE_ASSET__3561b67b__"